import { useEffect, useState } from 'react'

const secondsUntil = (at) => Math.ceil((at - Date.now()) / 1000)

const AutoBreakBanner = ({ at, className }) => {
  const [seconds, setSeconds] = useState(() => (at == null ? 0 : secondsUntil(at)))

  useEffect(() => {
    if (at == null) return undefined
    setSeconds(secondsUntil(at))
    const id = setInterval(() => setSeconds(secondsUntil(at)), 250)
    return () => clearInterval(id)
  }, [at])

  if (at == null || seconds <= 0) return null
  return <div className={className}>{`Break detected · Mismatch ad in ${seconds} s`}</div>
}

export default AutoBreakBanner
